import { Kicker, Reveal } from './Reveal';

export const PageHeader = ({ kicker, title, sub, img }) => (
  <section data-testid="page-header" className="relative overflow-hidden bg-eco-deep pt-32 pb-14 md:pt-36 md:pb-16">
    {img && (
      <>
        <img src={img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-eco-deep/70" />
      </>
    )}
    <div className="eco-container relative">
      <Reveal>
        <Kicker>{kicker}</Kicker>
        <h1 className="eco-page-title mt-4 max-w-3xl text-white">{title}</h1>
        {sub && <p className="mt-4 max-w-2xl text-base leading-[1.65] font-normal text-white/70">{sub}</p>}
      </Reveal>
    </div>
  </section>
);
